import(/* webpackMode: "eager" */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/components/atoms/Title/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/components/organisms/Legacy/Richtext/index.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/components/organisms/Wrapper/styles.scss");
